/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cms_Schemas_Articles_TitleInputs */

const en_cms_schemas_articles_title = /** @type {(inputs: Cms_Schemas_Articles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles`)
};

/**
* | output |
* | --- |
* | "Articles" |
*
* @param {Cms_Schemas_Articles_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cms_schemas_articles_title = /** @type {((inputs?: Cms_Schemas_Articles_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cms_Schemas_Articles_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cms_schemas_articles_title(inputs)
});